import { render, staticRenderFns } from "./NewReference.vue?vue&type=template&id=252aa75c&"
import script from "./NewReference.vue?vue&type=script&lang=ts&"
export * from "./NewReference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports